module.exports = __webpack_public_path__ + "static/media/image-12-full.f089cb47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-12-full.jpg
// module id = 356
// module chunks = 0